import { createAction } from "@reduxjs/toolkit";
import axios from 'apis';
import { asyncThunkWrapper } from 'helpers/asyncThunkWrapper';

const attributes = ['id', 'channel', 'mode', 'trigger', 'orchestrate'];

export const getConversations = asyncThunkWrapper({ 
  model: 'conversations', 
  action: 'getConversations', 
  func: async ({ offset = 0, patient_id, source }) => {
    const params = { limit: 25, offset, orders: { updated_at: 'desc' }, attributes };
    const response = await axios.get(`/patients/${patient_id}/conversations`, { params });

    return { data: response.data, source };
  } 
});
export const getConversation = asyncThunkWrapper({ 
  model: 'conversations', 
  action: 'getConversation', 
  func: async (id) => {
    const params = { attributes };
    const response = await axios.get(`/conversations/${id}`, { params });

    return response.data;
  } 
});
export const updateConversation = asyncThunkWrapper({ 
  model: 'conversations', 
  action: 'updateConversation', 
  func: async ({ id, ...fields }) => {
    const response = await axios.patch(`/conversations/${id}`, { conversation: { ...fields } });

    return { status: response.status, conversation: { id, ...fields } };
  } 
});
export const setDevMode = createAction('conversations/setDevMode');
export const clearLocalConversations = createAction('conversations/clearLocalConversations');
export const clearLocalActiveConversation = createAction('conversations/clearLocalActiveConversation');
